import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitotrimkeshwar() {



  const cardData =
  {
    keyword: 'Mumbai to Trimbakeshwar Cab',
    heading: 'Shambhu Cabs: Mumbai to Trimbakeshwar Cab',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Trimbakeshwar Cab services, providing safe, comfortable, and hassle-free travel for devotees, families, friends, and corporate travelers visiting the sacred town of Trimbakeshwar. Our fleet of well-maintained hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to Trimbakeshwar with spacious seating and clean interiors. With flexible one-way and round-trip options, professional chauffeurs, doorstep pickup across South Mumbai, Thane, Andheri, Navi Mumbai, and 24/7 booking support, Shambhu Cabs makes your pilgrimage or outstation trip convenient, stress-free, and memorable. For trusted, comfortable, and safe travel, Shambhu Cabs is your preferred choice for Mumbai to Trimbakeshwar cab services.',

    top: 'Top Places to Visit in Trimbakeshwar with Shambhu Cabs',

 
"topPlaces": [
  {
    "title": "Trimbakeshwar Jyotirlinga Temple",
    "description": "Trimbakeshwar Temple, located in Nashik district, Maharashtra, is one of the twelve Jyotirlingas dedicated to Lord Shiva. Renowned for its unique architecture, the temple features a sanctum with three lingams representing Brahma, Vishnu, and Shiva. The temple is a significant pilgrimage site, attracting devotees year-round, especially during the Kumbh Mela. Rituals, abhishekams, and spiritual ceremonies are performed daily, making it a vibrant center of devotion and religious heritage."
  },
  {
    "title": "Brahmagiri Hills",
    "description": "The Brahmagiri Hills surround Trimbakeshwar Temple and are considered sacred in Hindu mythology as the source of the Godavari River. Pilgrims and nature enthusiasts can enjoy scenic treks, peaceful walks, and breathtaking views of the hills and valleys. The hills are dotted with small shrines and meditation spots, providing a serene backdrop for spiritual reflection and photography."
  },
  {
    "title": "Godavari River Source",
    "description": "Located near Trimbakeshwar, the origin of the Godavari River at Brahmagiri Hills is a revered pilgrimage spot. Devotees perform rituals and take holy dips in the pristine waters, believing it purifies the soul and fulfills wishes. The serene surroundings, flowing waters, and spiritual ambiance make it a must-visit for both pilgrims and nature lovers."
  },
  {
    "title": "Neel Kund",
    "description": "Neel Kund is a sacred water tank located near the temple, known for its crystal-clear water and tranquil setting. Devotees believe that taking a ritualistic bath here washes away sins. The kund is surrounded by greenery, providing a peaceful environment for meditation and quiet contemplation amidst the spiritual aura of Trimbakeshwar."
  },
  {
    "title": "Panchavati Area",
    "description": "The Panchavati area around Trimbakeshwar is dotted with temples, ghats, and ashrams, offering pilgrims multiple spots for worship and spiritual engagement. The area is ideal for morning walks, exploring ancient architecture, and observing local rituals. Pilgrims can also find shops selling religious items, souvenirs, and local snacks, making the visit convenient and immersive."
  },
  {
    "title": "Shani Mandir",
    "description": "Shani Mandir near Trimbakeshwar Temple is dedicated to Lord Shani (Saturn) and attracts devotees seeking protection from obstacles and misfortunes. The temple is vibrant on Saturdays, with special rituals and offerings performed by priests. It adds a unique spiritual dimension to the Trimbakeshwar pilgrimage experience."
  },
  {
    "title": "Nearby Trekking Trails",
    "description": "The region around Trimbakeshwar offers trekking opportunities through lush green landscapes, hillocks, and forested paths. Trekkers and pilgrims alike enjoy exploring these trails while soaking in natural beauty, bird watching, and capturing panoramic views of the Godavari valley. These trails provide a combination of adventure and spiritual exploration."
  },
  {
    "title": "Local Handicraft and Food Stalls",
    "description": "The vicinity of Trimbakeshwar Temple features local stalls selling religious artifacts, souvenirs, and traditional Maharashtrian snacks. Visitors can sample delicacies like poha, misal pav, and sweets, adding a cultural flavor to their spiritual journey. These stalls enhance the overall experience by combining faith, tradition, and local lifestyle."
  },
  {
    "title": "Accommodation for Pilgrims",
    "description": "Trimbakeshwar has numerous dharmashalas, guesthouses, and small hotels offering convenient stays for pilgrims. Many of these accommodations provide meals and easy access to temple rituals, ensuring visitors can fully participate in religious ceremonies. Staying nearby also allows devotees to attend early morning aartis and evening prayers without hassle."
  },
  {
    "title": "Festival Celebrations",
    "description": "Trimbakeshwar Temple hosts grand celebrations during festivals like Maha Shivaratri and Kumbh Mela. Thousands of devotees gather to witness rituals, processions, and cultural events. The temple is adorned with decorations, lights, and flower arrangements, creating a vibrant spiritual atmosphere. These festivals provide a unique opportunity to experience the rich religious heritage and devotion of the region."
  }
],




"services": [
  {
    "name": "Mumbai Trimbakeshwar Taxi",
    "description": "Mumbai Trimbakeshwar Taxi offers a comfortable and reliable travel solution for devotees visiting the sacred Trimbakeshwar Jyotirlinga. With professional drivers, clean vehicles, and timely pickups from anywhere in Mumbai, this service ensures a peaceful and hassle-free pilgrimage journey, perfect for families, solo travellers, and groups."
  },
  {
    "name": "Trimbakeshwar from Mumbai Cab",
    "description": "Trimbakeshwar from Mumbai Cab provides a direct and convenient travel option for pilgrims and tourists. The cab service includes AC sedans and SUVs, expert drivers familiar with the route, and flexible pickup and drop timings, making long-distance travel comfortable and stress-free."
  },
  {
    "name": "Jyotirlinga Cab Mumbai",
    "description": "Jyotirlinga Cab Mumbai specializes in spiritual and temple tours, offering dedicated trips to Trimbakeshwar Jyotirlinga. Passengers enjoy safe, smooth rides with adequate space for family and luggage, ensuring a satisfying and serene pilgrimage experience."
  },
  {
    "name": "One Way Cab Mumbai Trimbakeshwar",
    "description": "One Way Cab Mumbai Trimbakeshwar is designed for travelers needing a single-direction trip to the holy site. Affordable fares, clean sedans and SUVs, and reliable service make it an ideal choice for devotees looking for a hassle-free journey from Mumbai to Trimbakeshwar."
  },
  {
    "name": "Mumbai Nashik Trimbak Taxi",
    "description": "Mumbai Nashik Trimbak Taxi is a long-route cab service connecting Mumbai to Trimbakeshwar via Nashik. With comfortable seating, highway-friendly vehicles, and experienced drivers, this service ensures a smooth, efficient, and timely pilgrimage trip."
  },
  {
    "name": "Affordable Cab Mumbai Trimbakeshwar",
    "description": "Affordable Cab Mumbai Trimbakeshwar offers budget-friendly travel without compromising on comfort or safety. Ideal for small families, solo travelers, and groups seeking a spiritual trip at economical rates, this service provides AC sedans, SUVs, and courteous drivers."
  },
  {
    "name": "SUV Cab Mumbai Trimbakeshwar",
    "description": "SUV Cab Mumbai Trimbakeshwar is perfect for larger groups or families who need more space and comfort on long pilgrimage routes. With smooth rides, ample luggage capacity, and reliable drivers, SUVs make the journey to Trimbakeshwar convenient and enjoyable."
  },
  {
    "name": "Sedan Cab Mumbai Trimbakeshwar",
    "description": "Sedan Cab Mumbai Trimbakeshwar provides a comfortable and affordable option for small families or individual travelers. Vehicles like Dzire and Etios offer AC comfort, smooth highway travel, and a peaceful environment suitable for a spiritual journey."
  },
  {
    "name": "24x7 Taxi Mumbai Trimbakeshwar",
    "description": "24x7 Taxi Mumbai Trimbakeshwar ensures round-the-clock availability for early morning departures, late-night trips, or urgent pilgrimages. Passengers can rely on instant booking, safe vehicles, and experienced drivers at any hour of the day or night."
  },
  {
    "name": "Mumbai Trimbakeshwar Temple Cab",
    "description": "Mumbai Trimbakeshwar Temple Cab is a specialized service for devotees visiting the Trimbakeshwar temple. With well-planned routes, comfortable vehicles, and attentive drivers, it offers a hassle-free and devotional travel experience from Mumbai."
  },
  {
    "name": "Pilgrimage Cab Mumbai Trimbakeshwar",
    "description": "Pilgrimage Cab Mumbai Trimbakeshwar is designed for religious trips, offering serene and comfortable rides for families, elderly devotees, and group travelers. The cab service emphasizes safety, punctuality, and a smooth travel experience to the holy Jyotirlinga."
  },
  {
    "name": "Fast Cab Mumbai Trimbakeshwar",
    "description": "Fast Cab Mumbai Trimbakeshwar ensures the quickest travel time by using optimized highway routes and professional driving. Ideal for passengers with tight schedules, this service guarantees timely arrival at Trimbakeshwar without compromising comfort or safety."
  },
  {
    "name": "Round Trip Mumbai Trimbakeshwar Cab",
    "description": "Round Trip Mumbai Trimbakeshwar Cab offers convenient return journeys for devotees traveling from Mumbai. With flexible scheduling, comfortable vehicles, and reliable drivers, passengers can complete their pilgrimage smoothly and return to Mumbai without any travel hassle."
  },
  {
    "name": "Family Cab Mumbai Trimbakeshwar",
    "description": "Family Cab Mumbai Trimbakeshwar ensures a safe and comfortable journey for families visiting the temple. Spacious vehicles, smooth driving, and friendly drivers make it perfect for family pilgrimages, including children and elderly members."
  },
  {
    "name": "Premium Cab Mumbai Trimbakeshwar",
    "description": "Premium Cab Mumbai Trimbakeshwar offers luxury sedans and SUVs for travelers seeking top-class comfort. With well-maintained vehicles, courteous drivers, and a smooth travel experience, this service provides a premium pilgrimage journey from Mumbai to Trimbakeshwar."
  }
],

"tableData": [
  ["Mumbai Trimbakeshwar Taxi", "Trimbakeshwar from Mumbai Cab"],
  ["Jyotirlinga Cab Mumbai", "One Way Cab Mumbai Trimbakeshwar"],
  ["Mumbai Nashik Trimbak Taxi", "Affordable Cab Mumbai Trimbakeshwar"],
  ["SUV Cab Mumbai Trimbakeshwar", "Sedan Cab Mumbai Trimbakeshwar"],
  ["24x7 Taxi Mumbai Trimbakeshwar", "Mumbai Trimbakeshwar Temple Cab"],
  ["Pilgrimage Cab Mumbai Trimbakeshwar", "Fast Cab Mumbai Trimbakeshwar"],
  ["Round Trip Mumbai Trimbakeshwar Cab", "Family Cab Mumbai Trimbakeshwar"],
  ["Premium Cab Mumbai Trimbakeshwar"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Trimbakeshwar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs provides reliable Mumbai to Trimbakeshwar cab services, ideal for pilgrimage trips, family visits, and comfortable long-distance journeys."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs to ensure a smooth and comfortable ride from Mumbai to Trimbakeshwar."
  },
  {
    "WhyChooseheading": "Experienced Pilgrimage Route Drivers",
    "WhyChoosedescription": "Our skilled drivers are familiar with Mumbai to Trimbakeshwar routes, ensuring safe driving, timely arrivals, and a stress-free journey."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide clear and upfront pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Trimbakeshwar cab booking."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel guidance, and any trip-related queries."
  },
  {
    "WhyChooseheading": "Flexible Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized travel plans tailored to your Mumbai to Trimbakeshwar journey."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before each trip, ensuring a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and dependable service, making your Mumbai to Trimbakeshwar travel smooth, comfortable, and worry-free."
  }
]




























  }

const faqData = [
  {
    question: 'Does Shambhu Cabs provide cab service from Mumbai to Trimbakeshwar?',
    answer: 'Yes, Shambhu Cabs offers reliable and comfortable cab services from Mumbai to Trimbakeshwar, making your pilgrimage to the Trimbakeshwar Temple seamless and enjoyable.',
  },
  {
    question: 'How can I book a cab from Mumbai to Trimbakeshwar?',
    answer: 'You can easily book a cab from Mumbai to Trimbakeshwar through our website, mobile app, or by contacting our 24x7 customer support team for easy and quick bookings.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Trimbakeshwar cab bookings?',
    answer: 'Shambhu Cabs offers a variety of vehicles for your journey from Mumbai to Trimbakeshwar, including sedans, SUVs, luxury cars, and Tempo Travellers for families or group trips.',
  },
  {
    question: 'Are the drivers experienced for the Mumbai to Trimbakeshwar journey?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route to Trimbakeshwar, ensuring a safe and comfortable journey throughout.',
  },
  {
    question: 'Can I customize my pickup and drop-off locations for the Mumbai to Trimbakeshwar trip?',
    answer: 'Yes, you can choose your preferred pickup and drop-off points within Mumbai and Trimbakeshwar, providing a personalized and convenient travel experience.',
  },
  {
    question: 'Is the Mumbai to Trimbakeshwar cab service available 24x7?',
    answer: 'Yes, Shambhu Cabs offers 24x7 cab services for your trip from Mumbai to Trimbakeshwar, allowing you to travel at any time based on your convenience.',
  },
  {
    question: 'Are safety and hygiene protocols followed for the Mumbai to Trimbakeshwar trip?',
    answer: 'Yes, all vehicles are sanitized regularly, and our drivers follow strict safety and hygiene protocols to ensure your well-being during the journey.',
  },
  {
    question: 'What payment options are available for Mumbai to Trimbakeshwar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate payments for all cab bookings from Mumbai to Trimbakeshwar.',
  },
  {
    question: 'Is customer support available during my Mumbai to Trimbakeshwar trip?',
    answer: 'Yes, Shambhu Cabs provides 24x7 customer support to assist you throughout your journey from Mumbai to Trimbakeshwar.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ashok Desai',
    feedback: 'Our journey from Mumbai to Trimbakeshwar was very pleasant with Shambhu Cabs. The driver was knowledgeable, the car was clean, and the ride was comfortable.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meena Patel',
    feedback: 'Shambhu Cabs made our trip to Trimbakeshwar smooth and stress-free. Excellent service, great communication, and punctual drivers made the journey enjoyable.',
    rating: 5,
  },
];












































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];








const trimbakeshwarCabSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Mumbai to Trimbakeshwar Cab",
  "serviceType": "Pilgrimage / Outstation Cab Service",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-trimbakeshwar-cab.jpg",
  "description": "Book reliable Mumbai to Trimbakeshwar cab services with Shambhu Cabs. Affordable and premium cabs including SUV, sedan, family trips, Jyotirlinga darshan, and 24×7 service.",
  "brand": { "@type": "Brand", "name": "Shambhu Cabs" },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "680",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "5000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-trimbakeshwar-cab"
  },
  "areaServed": { "@type": "Place", "name": "Mumbai, Trimbakeshwar, India" }
};




  return (
    <div>

<Helmet>
  <title>Mumbai to Trimbakeshwar Cab | Shambhu Cabs</title>

  <meta
    name="description"
    content="Shambhu Cabs offers Mumbai to Trimbakeshwar cab services. Book affordable SUV, sedan, family cabs for Jyotirlinga darshan, temple trips, and outstation travel, available 24×7."
  />

  <meta
    name="keywords"
    content="Mumbai Trimbakeshwar Taxi, Trimbakeshwar from Mumbai Cab, Jyotirlinga Cab Mumbai, One Way Cab Mumbai Trimbakeshwar, Mumbai Nashik Trimbak Taxi, Affordable Cab Mumbai Trimbakeshwar, SUV Cab Mumbai Trimbakeshwar, Sedan Cab Mumbai Trimbakeshwar, 24x7 Taxi Mumbai Trimbakeshwar, Mumbai Trimbakeshwar Temple Cab, Pilgrimage Cab Mumbai Trimbakeshwar, Fast Cab Mumbai Trimbakeshwar, Round Trip Mumbai Trimbakeshwar Cab, Family Cab Mumbai Trimbakeshwar, Premium Cab Mumbai Trimbakeshwar"
  />

  <script type="application/ld+json">
    {JSON.stringify(trimbakeshwarCabSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/63.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitotrimkeshwar;